export default {
  methods: {
    calcInventoryQty(type, list) {
      let qty = 0;
      for (var i = 0; i < list.length; i++) {
        if (type === "Stock" || type === "ALL") {
          qty = qty + parseInt(list[i].char.stocur);
        }
        if (type === "Order" || type === "ALL") {
          qty = qty + parseInt(list[i].char.stoord);
        }
      }
      if (isNaN(qty)) {
        qty = "NA";
      } else {
        qty = qty.toString();
      }
      return qty;
    }
  }
};
